import { Component, OnInit, ɵConsole } from '@angular/core';

@Component({
  selector: 'app-access-bar',
  templateUrl: './access-bar.component.html',
  styleUrls: ['./access-bar.component.scss']
})
export class AccessBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  accessMod(value: any) {
    switch (value) {
      case 0:
        $('body').toggleClass("contrast");
        break;
      case 1:
        resizeText(-1);
        break;
      case 2:
        resizeText(1);
        break;
      default:
        break;
    }
  }

}

let sizeCount = 0;

function resizeText(multiplier) {
  // if (document.body.style.fontSize == "") {
  //   document.body.style.fontSize = "16px";
  // }
  // document.body.style.fontSize = parseFloat(document.body.style.fontSize) + (multiplier) + "px";
  // $('*').each(function () {
  //   $(this).css('fontSize', $(this).css('fontSize').split('px')[0] * 0.9);
  // }
  if( sizeCount > -3 && sizeCount < 3){
    console.log("1");
    $('*').each( function() {
      if($(this).prev().prop('nodeName') !== 'DIV'){
        console.log("before: ", $(this).css('fontSize'));
        $(this).css('fontSize', <any>(parseFloat($(this).css('fontSize').split('px')[0])) + multiplier);
        console.log("after: ", $(this).css('fontSize'));
      }
    });
    multiplier == 1? sizeCount++:sizeCount--;
  }
  if (sizeCount == 3 && multiplier == -1) {
    console.log("2");
    $('*').each( function() {
      if($(this).prev().prop('nodeName') !== 'DIV'){
        console.log("before: ", $(this).css('fontSize'));
        $(this).css('fontSize', <any>(parseFloat($(this).css('fontSize').split('px')[0])) + multiplier);
        console.log("after: ", $(this).css('fontSize'));
      }
    });
    sizeCount--;
  }
  if (sizeCount == -3 && multiplier == 1) {
    console.log("3");
    $('*').each( function() {
      if($(this).prev().prop('nodeName') !== 'DIV'){
        console.log("before: ", $(this).css('fontSize'));
        $(this).css('fontSize', <any>(parseFloat($(this).css('fontSize').split('px')[0])) + multiplier);
        console.log("after: ", $(this).css('fontSize'));
      }
    });
    sizeCount++;
  }
}
